import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomerService } from 'src/app/shared/customer/customer.service';
import { ExpertService } from 'src/app/shared/techExpert/expert.service';
import { LoginService } from 'src/app/shared/user-login/login.service';


@Component({
    selector: 'app-create-user',
    templateUrl: './create-user.component.html',
    styleUrls: ['./create-user.component.css'],
    standalone: false
})
export class CreateUserComponent implements OnInit {

  userType;
  role;
  serverErrorMessages: String;
  customerForm = new FormGroup({
    userName: new FormControl('',
    [Validators.required]),
    fullName: new FormControl('',
    [Validators.required]),
    contactNumber: new FormControl('',
    [Validators.required,
    Validators.minLength(10),
    Validators.maxLength(10)]),
    pContactNumber: new FormControl('',
    [Validators.required,
    Validators.minLength(10),
    Validators.maxLength(10)]),
    email: new FormControl('',
    [Validators.required,
    Validators.email]),
    pEmail: new FormControl('',
    [Validators.required,
    Validators.email]),
    companyName: new FormControl('',
    [Validators.required]),


      // BANKING DETAILS
    gstNumber: new FormControl('11AAAAA0000A1Z5',
    [Validators.required,
     Validators.minLength(15),
     Validators.maxLength(15)]),
    PAN: new FormControl('AAAAA0000A',
    [Validators.required,
     Validators.minLength(10),
     Validators.maxLength(10)]),
    currency: new FormControl('',
    [Validators.required]),
    bankName: new FormControl('',
    [Validators.required]),
    bankAccountNumber: new FormControl('',
    [Validators.required]),
    IFSC: new FormControl('',
    [Validators.required,
    Validators.minLength(11),
    Validators.maxLength(11)]),
    SWIFT: new FormControl('',
    [Validators.required,
     Validators.minLength(11),
     Validators.maxLength(11)])



  })


  techExpertForm = new FormGroup({
    userName: new FormControl('',
    [Validators.required]),
    fullName: new FormControl('',
    [Validators.required]),
    contactNumber: new FormControl('',
    [Validators.required,
    Validators.minLength(10),
    Validators.maxLength(10)]),
    email: new FormControl('',
    [Validators.required,
    Validators.email]),
  })
  constructor(private loginService: LoginService, private router : Router,public customerService: CustomerService,public expertService: ExpertService,) { }

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
        }
      )
    }
  }

  changeUser(event){
   //console.log(event.value)
    this.userType = event.value;
  }

  onSubmit(){
   //console.log('cae here')
    if(this.userType === 'CUSTOMER'){
     //console.log('creating customer')
     //console.log(this.customerForm.getRawValue());
      this.customerService.postCustomer({...this.customerForm.value, role: 'CUSTOMER'.toUpperCase()}).subscribe(
        res => {
         //console.log('success', res);
          alert('User created!')
          this.router.navigateByUrl('/home');
        },
        err => {
         //console.log('error inside',err)
          this.serverErrorMessages = err.error.message;
        }
      );
    }else if(this.userType === 'TECHEXPERT'){
     //console.log('creatng expert')
     //console.log(this.techExpertForm.getRawValue());
      this.expertService.postExpert({...this.techExpertForm.value, role: 'TECHEXPERT'.toUpperCase()}).subscribe(
        res => {
         //console.log('success', res);
          alert('User created!')
          this.router.navigateByUrl('/home');
        },
        err => {
         //console.log('error inside',err)
          this.serverErrorMessages = 'err.error.message';
        }
      );
    }
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }
}
